import {ApiAxiosInstance, create} from "@/helpers/api";

export const delivery: ApiAxiosInstance = create();

export default delivery